module.exports = __webpack_public_path__ + "img/2_1-residenziale-biblioteca-2.f573673b.png";